import React from 'react';
import './analytics.css';

/**
 * FunnelChart - Conversion funnel visualization
 *
 * Props:
 *   data       - Array of { step, count } ordered from top to bottom of funnel
 *   title      - Chart title (optional)
 *   loading    - Show loading skeleton (optional)
 *   colors     - Array of colors for each step (optional)
 */
export default function FunnelChart({
  data = [],
  title,
  loading,
  colors = ['#667eea', '#818cf8', '#a78bfa', '#c4b5fd'],
}) {
  if (loading) {
    return (
      <div className="an-chart-container">
        {title && <h4 className="an-chart-title">{title}</h4>}
        <div className="an-chart-skeleton" style={{ height: 200 }} />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="an-chart-container">
        {title && <h4 className="an-chart-title">{title}</h4>}
        <div className="an-chart-empty" style={{ height: 200 }}>
          <span>No data available yet</span>
        </div>
      </div>
    );
  }

  const maxCount = Math.max(...data.map(d => d.count), 1);

  return (
    <div className="an-chart-container">
      {title && <h4 className="an-chart-title">{title}</h4>}
      <div className="an-funnel">
        {data.map((step, i) => {
          const widthPercent = Math.max((step.count / maxCount) * 100, 15);
          const dropoff = i > 0 && data[i - 1].count > 0
            ? Math.round(((data[i - 1].count - step.count) / data[i - 1].count) * 100)
            : null;

          return (
            <div key={i} className="an-funnel-step">
              <div className="an-funnel-label">
                <span className="an-funnel-step-name">{step.step}</span>
                <span className="an-funnel-step-count">{step.count.toLocaleString()}</span>
              </div>
              <div className="an-funnel-bar-track">
                <div
                  className="an-funnel-bar"
                  style={{
                    width: `${widthPercent}%`,
                    backgroundColor: colors[i % colors.length],
                  }}
                />
              </div>
              {dropoff !== null && dropoff > 0 && (
                <span className="an-funnel-dropoff">-{dropoff}%</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
